export default __webpack_public_path__ + "static/media/choice-hunting-site.87312fb0.png";